//
import ExtendModel from '@/models/ExtendModel'

//
import DetailPurchaseOrder from '@/models/Purchase/PchDetailPurchaseOrder'

/**
 * This class describes a wh product.
 *
 * @class      WhProduct (name)
 */
export default class WhProduct extends ExtendModel {

    /**
     * default enpoint appends
     */
    static appends = ['branch_offices', 'last_provider_code']

    //
    static headers = [
        {
            text: '#',
            value: 'id',
            width: '5%',
        },
        {
            text: 'código interno',
            value: 'internal_code',
            width: '15%',
        },
        {
            text: 'alias',
            value: 'alias_name',
        },
        {
            text: 'nombre',
            value: 'name',
        },
        {
            text: 'inventariable',
            value: 'wh_item_is_inventoriable',
            align: 'center',
            format: 'boolean',
        },
        {
            text: 'reenvasable',
            value: 'is_repackaged',
            align: 'center',
            format: 'boolean',
        },
    ]

    /**
     * @description
     * Find the branch office by id
     *
     * @param      {<type>}                        id      The identifier
     * @return     {(DetailPurchaseOrder|string)}  branch office
     */
    findBranchOfficeById = id => item => item.g_branch_office_id === id

    /**
     * @description
     * Enpoint location
     *
     * @return     {string}  enpoint name
     */
    resource() {
        return 'wh_product'
    }

    /**
     * @description
     * Cast to Detail Purchase Order
     *
     * @param      {Object}               props   properties
     * @return     {DetailPurchaseOrder}  purchase order detail class
     */
    toDetailPurchaseOrder(props) {

        // get current branch office price data
        const aux_branch_office_id = props.g_branch_office_id
        const aux_branch_office = this.branch_offices ? this.branch_offices.find(this.findBranchOfficeById(aux_branch_office_id)) : {}

        // set nested wh product
        this.wh_product = this
        this.wh_product_id = this.id

        // required data
        this.net_price = this.cost_price_branch_office || aux_branch_office.cost_price || this.net_price
        this.provider_product_code = this.last_provider_code_provider || ''
        this.quantity = 1
        this.received = 0
        this.stock = 0
        this.stock_branch = 0

        // new data
        return new DetailPurchaseOrder(
            this.clean([
                'id',
                'net_price',
                'quantity',
                'received',
                'stock',
                'stock_branch',
                'provider_product_code',
                'wh_product',
                'wh_product_id',
            ])
        )
    }
}
